export default __webpack_public_path__ + "static/media/HTC One.e59b7a43.png";